import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class RouteApi extends CrudBase {

  getRoutes = (params) => axios.get(`${this.endpoint}/get-by`, params);
  updateRoute = (data) => axios.post(`${this.endpoint}/update`, data);

  defaultMethods = {
    ...this.defaultMethods,
    getRoutes: this.getRoutes,
    updateRoute: this.updateRoute,
  }
}

const route = new RouteApi('/api/v1/route');

export default route.defaultMethods;

